
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollEmployeeDetailsGrid extends Serenity.EntityGrid<PayrollEmployeeDetailsRow, any> {
        protected getColumnsKey() { return 'HR.PayrollEmployeeDetails'; }
        protected getDialogType() { return PayrollEmployeeDetailsDialog; }
        protected getIdProperty() { return PayrollEmployeeDetailsRow.idProperty; }
        protected getInsertPermission() { return PayrollEmployeeDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return PayrollEmployeeDetailsRow.localTextPrefix; }
        protected getService() { return PayrollEmployeeDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}